/* eslint-disable */
import React, { useEffect } from "react";
import { getNeighborsCalendar } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";
import "./CalendarCommunities.scss";

const CalendarCommunities = ({ getNeighborsCalendar, communityCalendar, period }) => {
  useEffect(() => {
    getNeighborsCalendar({
      page: 1,
      limit: 20,
    });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getNeighborsCalendar(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getNeighborsCalendar(payload);
  };

  return (
    <DataTable
      preset="calendarCommunities"
      data={{
        docs: communityCalendar?.docs || [],
        totalPages: communityCalendar?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={false}
    />
  );
};

const mapStateToProps = (state) => ({
  communityCalendar: state.appCommunities.communityCalendar,
});

const mapDispatchToProps = (dispatch) => ({
  getNeighborsCalendar: (payload) => dispatch(getNeighborsCalendar(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarCommunities);
